import api from "../utils/axios";

export const fetchFinances = async () => {
	try {
		const response = await api.get("Finance/dashboard-finances");
		if (response.status === 200) {
			const result = response.data[0];
			return result;
		}
	} catch (error) {
		console.log(error);
	}
};
